// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Arsenal', 'Arsenal Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_65355a","variable":"__variable_65355a"};